var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"TheOffersNav"},[_c('ul',_vm._l((_vm.items),function(item,i){return _c('li',{key:item},[_c('a',{class:_vm.getActiveClass(i),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.handleClick(i)}}},[_c('span',[_vm._v(_vm._s(item))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }